var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWidgetList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.725,
    height: 14.335,
    viewBox: "0 0 16.725 14.335",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.618 5.973H6.69c-.659 0-.717.534-.717 1.195s.057 1.195.717 1.195h6.929c.659 0 .717-.534.717-1.195s-.058-1.195-.718-1.195zm2.389 5.973H6.69c-.659 0-.717.534-.717 1.195s.057 1.195.717 1.195h9.318c.659 0 .717-.534.717-1.195s-.058-1.195-.717-1.195zM6.69 2.389h9.318c.659 0 .717-.534.717-1.195S16.667 0 16.008 0H6.69c-.659 0-.717.534-.717 1.195s.057 1.194.717 1.194zM2.867 5.973H.717C.058 5.973 0 6.507 0 7.168s.057 1.195.717 1.195h2.15c.659 0 .717-.534.717-1.195s-.058-1.195-.717-1.195zm0 5.973H.717c-.659 0-.717.534-.717 1.195s.057 1.195.717 1.195h2.15c.659 0 .717-.534.717-1.195s-.058-1.195-.717-1.195zM2.867 0H.717C.058 0 0 .534 0 1.195S.057 2.39.717 2.39h2.15c.659 0 .717-.534.717-1.195S3.526 0 2.867 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWidgetList);
export default __webpack_public_path__ + "static/media/widget-list.a93d06e2.svg";
export { ForwardRef as ReactComponent };